import { render, staticRenderFns } from "./AdminApplications.vue?vue&type=template&id=1fdd44e9"
import script from "./AdminApplications.vue?vue&type=script&lang=js"
export * from "./AdminApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports